export const TRANSLATIONS = {
  LOG_OUT_BUTTON: 'Log out',
}
